var Store   = require('./state');
var request = require('superagent');

var state = {}, stageId;
Store.on("submit", function(stageId, csrfToken){
  Store.get()[stageId].set({status: 'saving'});

  request.post("/approvals/quiz/" + stageId)
    .set('Accept', 'application/json')
    .set('X-Requested-With', 'XMLHttpRequest')
    .set('X-CSRF-Token', csrfToken)
    .send({ responses: Store.get()[stageId].questions })
    .end(function(errors, response){
        if (response.ok){
          Store.get()[stageId].set({
            pointsEarned: response.body.points_earned,
            questions: response.body.questions,
            totalQuestions: response.body.total_questions,
            correctQuestions: response.body.correct_questions,
            quizAnswered: true,
            errorMsg: null,
            status: 'saved'
          });
        } else {
          Store.get()[stageId].set({
            errorMsg: response.body.errorMsg,
            status: 'error'
          });
        }
      }.bind(this)
    );
});

Store.on("saveAnswer", function(questionId, answer){
  var question = Store.get()[stageId].questions[questionId];
  var state = question.set('selectedAnswer', answer);

  Store.get()[stageId].set("status", 'unsaved');
});

Store.on("initialize", function(questions, _stageId){
  stageId = _stageId;
  state[stageId] = {
    questions: questions,
    errorMsg: null,
    status: 'unsaved'
  };
  Store.get().set(state).now();
});



// WEBPACK FOOTER //
// ./src/advocate/stages/quiz/store.js